<template>
  <v-ons-page>

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">Nouveau partage</div>
    </v-ons-toolbar>

    <div class="content">

      <app-error-msg :list="errorMsgList"></app-error-msg>

      <v-ons-list modifier="noborder perflist">

        <app-label input-id="inputEmail" label="Email qui pourra accéder à votre compte" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputEmail" ref="inputEmail" input-type="email" v-model="email"
                   placeholder="Entrez un email" @keyup-enter="addShare"></app-input>

      </v-ons-list>

      <footer class="footer--perfbutton">
        <v-ons-button modifier="large--cta perflarge" @click="addShare" :disabled="! email">
          Partager mon compte
          <v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
        </v-ons-button>
      </footer>

    </div>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';

import { store } from "../store.js";

import AppErrorMsg from '../partials/ErrorMsg.vue';
import AppLabel from '../partials/Label.vue';
import AppInput from '../partials/Input.vue';

export default {
  mixins: [mixinsCommons],
  components: { AppErrorMsg, AppLabel, AppInput },
  props: ['pageStack'],
  data() {
    return {
      email: '',
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
  },
  methods: {
    async addShare() {
      if(this.isSubmit){
        return;
      }
      this.isSubmit = true;

      const body = {
        id: this.user.id,
        date: this.user.date,
        email_to: this.email
      };

      const fetchInit = this.$getFetchInit();
      fetchInit.body = JSON.stringify(body);
      const callPath = this.$apiDomain + this.getPath('/share');
      try {
        const response = await this.handleRequest(callPath, fetchInit);

        this.updateUserFromResponse(response.user);

        if(response.multi && Object.keys(response.multi).length){
          this.$emit('set-multi', response.multi);
        }

        this.pageStack.length > 1 && this.pageStack.pop();
        this.$showToast('Nouveau partage ajouté');

      } catch(error) {
        this.handleError(error, 'du partage de votre compte');
      }
    }
  }
};
</script>
